/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useSelector } from 'react-redux';

import { tableMetaSortSelector, tableMetaUrlSelector } from '../../../selectors';

export const useTableSort = (fieldName: string) => {

    const metaUrl = useSelector(tableMetaUrlSelector);

    const sort = useSelector(tableMetaSortSelector(metaUrl));

    return {
        sort: sort?.property === fieldName ? sort : undefined,
    };
};
